import { SITE_CONFIG } from '../config';
import { decryptPassword } from '../utils/decrypt';
import { submitChatLead } from './chatLeadService';
import { HONEYPOT_FIELD_NAME } from '../components/HoneypotField';

const API_KEY = 'treas-api-key-2025';

const getSenderCredentials = async () => {
  try {
    const res = await fetch(`https://tophamtechbe.com/api/treas/idx/v1/feature-flag?siteId=${SITE_CONFIG.SITE_ID}`, { headers: { 'X-API-Key': API_KEY } });
    if (res.ok) {
      const data = await res.json();
      if (data.senderEmail && data.senderEmailPassword) {
        const pw = await decryptPassword(data.senderEmailPassword);
        if (pw) return { senderEmail: data.senderEmail, emailPassword: pw };
      }
    }
  } catch (e) {}
  return {};
};

const createSubscription = async (userInput, searchFilters, cadence) => {
  const sender = await getSenderCredentials();
  const res = await fetch('https://tophamtechbe.com/api/treas/comm/property-search-subscriptions', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'X-API-Key': API_KEY },
    body: JSON.stringify({
      customerName: userInput.name,
      agentName: SITE_CONFIG.AGENT.NAME,
      emailAddress: userInput.email,
      siteId: SITE_CONFIG.SITE_ID,
      cadence: cadence || 'daily',
      listingBaseUrl: window.location.origin,
      ...sender,
      searchFilters,
    }),
  });
  if (!res.ok) throw new Error(`Subscription failed: ${res.status}`);
  return res.json();
};

const createChatLead = async ({ name, email, phoneNumber, postalCode, area }) => {
  const params = new URLSearchParams({ name, email, postalCode, area, serviceReq: 'buying', siteId: SITE_CONFIG.SITE_ID });
  if (phoneNumber) params.set('phoneNumber', phoneNumber);
  const res = await submitChatLead(params, { rememberContact: true });
  if (!res.ok) throw new Error(`Chat lead failed: ${res.status}`);
  return res.json();
};

export const submitSearchLead = async (userInput, searchFilters, cadence) => {
  if (userInput?.[HONEYPOT_FIELD_NAME]?.trim()) {
    console.info('Search lead submission suppressed by spam protection.');
    return { subscription: { accepted: true }, lead: { accepted: true } };
  }

  const [subscription, lead] = await Promise.all([
    createSubscription(userInput, searchFilters, cadence),
    createChatLead(userInput),
  ]);
  return { subscription, lead };
};
